const initialState = {
    products: [],
};

const amazingOffers = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_AMAZING_OFFERS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default amazingOffers;
